// ======================================================================
// File Name       : userHistoryStudent
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../constants/actionTypes/userHistoryStudent';

export function receiveGetGroupRelationList(groupRelationList, recordNum) {
  return {
    type: ActionTypes.USER_STUDENT_GET_GROUP_RELATION_LIST,
    groupRelationList,
    recordNum,
  };
}

export function receiveGetUserList(userList, recordNum) {
  return {
    type: ActionTypes.USER_STUDENT_GET_USER_LIST,
    userList,
    recordNum,
  };
}

export function receiveGetCourseByUserList(courseStatusList) {
  return {
    type: ActionTypes.USER_STUDENT_GET_COURSE_STATUS_LIST,
    courseStatusList,
  };
}

export function receiveEachUserCourseStatusCount(courseStatusList) {
  return {
    type: ActionTypes.GET_EACH_USER_COURSE_STATUS_COUNT,
    courseStatusList,
  };
}

export function receiveGetUserHistoryCourseInfoList(courseList) {
  return {
    type: ActionTypes.USER_STUDENT_GET_COURSE_INFO_LIST,
    courseList,
  };
}

export function resetLearningHistoryList() {
  return {
    type: ActionTypes.RESET_LEARNING_HISTORY_LIST,
  };
}

export function receiveGetHistoryListByCourseList(learningHistoryList, recordNum) {
  return {
    type: ActionTypes.USER_STUDENT_GET_HISTORY_LIST,
    learningHistoryList,
    recordNum,
  };
}

export function receiveGetCourseList(courseList) {
  return {
    type: ActionTypes.USER_STUDENT_GET_COURSE_LIST,
    courseList,
  };
}

export function receiveGetContentList(contentList) {
  return {
    type: ActionTypes.USER_STUDENT_GET_CONTENT_LIST,
    contentList,
  };
}

export function receiveItemList(result) {
  return {
    type: ActionTypes.USER_STUDENT_GET_ITEM_LIST,
    itemList: result ? result.itemList : [],
  };
}

export function receiveQuestionUseRecordByStd(result) {
  return {
    type: ActionTypes.RECEIVE_QUESTION_USE_RECORD_BY_STD,
    result,
  };
}

export function receiveDrillEnforceHistoryByHash(drillResult, partQuestionList) {
  return {
    type: ActionTypes.RECEIVE_DRILL_ENFORCE_HISTORY_BY_STD,
    drillResult,
    partQuestionList,
  };
}

export function receiveQuestionHistoryReviewHtml(redirectUri) {
  return {
    type: ActionTypes.RECEIVE_QUESTION_HTML_DETAIL,
    redirectUri,
  };
}

export function saveHistoryCourseDetail(courseDetail) {
  return {
    type: ActionTypes.SAVE_HISTORY_COURSE_DETAIL,
    courseDetail,
  };
}

export function resetHistoryCourseDetail() {
  return {
    type: ActionTypes.RESET_HISTORY_COURSE_DETAIL,
  };
}

export function resetCourseStatusList() {
  return {
    type: ActionTypes.RESET_COURSE_STATUS_LIST,
  };
}

export function receiveUserHistoryDetailInitData(userList, groupRelationList, groupList) {
  return {
    type: ActionTypes.RECEIVE_USER_HISTORY_DETAIL_INIT,
    userList,
    groupRelationList,
    groupList,
  };
}
